import { type PropsOf } from '@emotion/react';
import { type SxProps, type Theme, type SnackbarProps } from '@mui/material';
import { type ReactNode } from 'react';
import { type FormattedMessage, type MessageDescriptor } from 'react-intl';

export const SnackbarVariant = {
  LIGHT: 'light',
  DARK: 'dark',
} as const;

export type SnackbarVariant = (typeof SnackbarVariant)[keyof typeof SnackbarVariant];

export interface SnackbarAction {
  onClick?: VoidFunction;
  label: MessageDescriptor;
}

export interface SnackbarPayload {
  message: MessageDescriptor;
  onCloseCallback?: () => void;
  action?: SnackbarAction;
  values?: PropsOf<typeof FormattedMessage>['values'];
  icon?: ReactNode;
  variant?: SnackbarVariant;
  autoHide?: boolean;
  autoHideDuration?: number;
  anchorOrigin?: SnackbarProps['anchorOrigin'];
  messageTitle?: MessageDescriptor;
  sx?: SxProps<Theme>;
}
